<script setup lang="ts">
import UiModal from '@boats/ui/components/UiModal.vue'

const router = useRouter()
const modals = useModalsStore()

const onSubmit = (event: Event) => {
  event.preventDefault()

  const formData = new FormData(event.target as HTMLFormElement)
  const q = formData.get('q') as string

  if (q) {
    router.push({
      path: '/search',
      query: { q },
    })
  }

  modals.closeSearchModal()
}
</script>

<template>
  <UiModal
    v-model="modals.isSearchModalOpen"
    class="app-modal-search"
    @close="modals.closeSearchModal"
  >
    <form class="search-form" @submit="onSubmit">
      <AppTextField
        class="mb-5 md:mb-6"
        :placeholder="`${$t('string.Search')}...`"
        full-width
        name="q"
        auto-focus
      />
    </form>

    <button class="close-icon" @click="modals.closeSearchModal">
      <IconClose />
    </button>
  </UiModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-search {
  .ui-modal__content {
    display: flex;
    flex-direction: column;
    width: 66.25rem;
  }

  .ui-modal__content {
    padding: 0;
    margin-top: 1.75rem;

    @include media-breakpoint-up(md) {
      margin-top: 10vh;
    }

    form {
      margin: 0;
    }

    input {
      height: 3.25rem;
      padding: 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      border: 1px solid $black;
      border-radius: 0.125rem;

      @include media-breakpoint-up(md) {
        height: 5.5rem;
        padding: 1rem 3rem;
        font-size: 1.25rem;
        border: 0.125rem solid $black;
        border-radius: 0.25rem;
      }
    }

    .close-icon {
      position: absolute;
      top: 50%;
      right: 0.75rem;
      width: 1.25rem;
      height: 1.25rem;
      transform: translateY(-50%);
      color: $black;

      @include media-breakpoint-up(md) {
        right: 2rem;
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .ui-modal__close {
    display: none;
  }

  .app-text-field {
    margin: 0;
  }
}
</style>
